module.exports = __webpack_public_path__ + "static/foto2-d5619651d2055f1e833b18280e376d63.jpg";